import { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from "react-router-dom";
import 'react-slidedown/lib/slidedown.css';
import { getData } from "../../api";
import Popup from "../popup/popup";
import './main.scss';

import { Helmet } from "react-helmet";
import { Mixpanel } from "../../mixpanel";
import Header from "../header/header";
import MainContent from './MainContent';
import MainContentInsurance from './MainContentInsurance';

interface MainProps {
    type?: 'pension' | 'insurance';
}

const Main = ({ type = 'pension' }: MainProps) => {
    Mixpanel.track( 'Page view',{page: `main-${type}`});
    const navigate = useNavigate();
    const [showNotInterestedPopup, setShowNotInterestedPopup] = useState(false);
    const [savingAmount, setSavingAmount] = useState(0);

    const [data, setData] = useState<any>({});
    const [showSavingDetails, setShowSavingDetails] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [height, setHeight] = useState(0);

    const wrapperRef = useRef<HTMLDivElement>(null)
    const buttonsRef = useRef<HTMLDivElement>(null)

    const {state} = useLocation();

    const loadData = async (idNumber: string, token: string) => {
        try {
            const result = await getData(idNumber, token || '', type);
            Mixpanel.identify(idNumber);
            Mixpanel.people.set({
                first_name: result.data.clientName,
                gender: result.data.gender,
                idNumber: idNumber,
                numOfProducts: state?.products.length,
                type,
            });

            setData(result.data);
        } catch (err) {
            console.log(err);
            window.localStorage.removeItem("idNumber");
            const basePath = type === 'insurance' ? '/insurance/' : '/pension/';
            navigate(basePath + token);
        } finally {
            setIsLoading(false);
        }
    }

    useEffect(() => {
        console.log("state change", state)
        if (state) {
            setData(state);
        } else {
            const idNumber = window.localStorage.getItem("idNumber");
            const token = window.localStorage.getItem("token");
            const basePath = type === 'insurance' ? '/insurance/' : '/pension/';
            if (idNumber && token) {
                loadData(idNumber, token);
                return;
            } else if (token) {
                navigate(basePath + token);
                return;
            } else {
                navigate(basePath + "a");
                return;
            }
        }

        setSavingAmount(state.products.reduce((total: number, p: any) => total + p.potentialSavings, 0));
    }, state);



    const proceedToSign = () => {
        Mixpanel.track( 'proceed to sign clicked',{success: true});
        localStorage.setItem("gender", state.gender)
        navigate("/sign",{state: {...state, type}});
    }

    const notInterestedClicked = () => {
        setShowNotInterestedPopup(true);
    }


    
    useEffect(()=>{
        window.addEventListener('resize', ()=>{
            if (buttonsRef?.current?.clientHeight) {
                setHeight(window.innerHeight - buttonsRef.current.clientHeight);
            }
        });
    },[])

    useEffect(() => {
        if (buttonsRef?.current?.clientHeight) {
            setHeight(window.innerHeight - buttonsRef.current.clientHeight);
        }
    })




    const pageTitle = type === 'insurance' ? 'סיכום השיחה על ביטוחים' : 'סיכום השיחה הפנסיונית';

    return (
        <>
            <Helmet>
                <meta property="og:title" content={pageTitle} />
                <meta property="og:url" content={`https://client.allbetter.co.il${type === 'insurance' ? '/insurance' : '/pension'}/${window.localStorage.getItem("token")}`} />
                <title>{pageTitle}</title>
                <meta property="og:description" content={`חיסכון מצטבר עבור ${data?.clientName}`} />
                <meta name="description" content={`חיסכון מצטבר עבור ${data?.clientName}`} />
            </Helmet>
            {showNotInterestedPopup &&
                <Popup
                    onClose={() => setShowNotInterestedPopup(false)}
                    button2Text={data?.gender === 'female' ? 'מאשרת' : 'מאשר'}
                    button1Text="כן רוצה לחסוך!"
                >
                    <div className="title">ויתור על הצעה לחיסכון</div>
                    <div className="content">
                        <div className="text1">
                            <p>{data?.clientName} האם אתה בטוח?</p>
                            <p>                            אנו בכל מקרה נמשיך עם איתור חסכונות בעולמות הפיננסים הבאים 💪
                                במידה ודעתך תשתנה, תמיד ניתן לעדכן אותנו בוואסטאפ
                            </p>
                        </div>
                    </div>
                </Popup>}

            

            <div className="main">
                <div className="wrapper" ref={wrapperRef} style={showSavingDetails?{height:'auto'}:{height: height+'px',overflowY:'auto'}}>
                    <Header />
                    {type === 'insurance' ? (
                        <MainContentInsurance
                            data={data}
                            state={state}                            
                        />
                    ) : (
                        <MainContent
                            data={data}                                                        
                            state={state}
                        />
                    )}
                </div>
                <div className="buttons" ref={buttonsRef}>
                    <button className="approve-button" onClick={proceedToSign}>רוצה להתקדם</button>
                    <div className="not-interested">
                        <u onClick={notInterestedClicked}>לא {data?.gender === 'female' ? 'מעוניינת' : 'מעוניין'}{" "}לחסוך</u>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Main;
